import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom'; // Added to capture dynamic page paths

const SEOHelmet = ({
  title = 'Encyclopedia of Ludic Terms',
  description = 'An open-access lexicon covering terms related to the study of games and play',
  type = 'website',
  noIndex = false
}) => {
  const location = useLocation();

  // Set live absolute domain 
  const baseDomain = "https://eolt.org";

  // Safely strip any trailing slashes so both structural file variations 
  // generated by react-snap point to the exact same clean canonical path string
  const cleanPath = location.pathname.endsWith('/') || location.pathname === '/'
  ? location.pathname
  : location.pathname + '/';

  const canonicalUrl = `${baseDomain}${cleanPath}`;

  return (
    <Helmet>
      {/* Dynamic Canonical Link element */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Your existing properties remain completely unchanged */}
      <title>{title}</title>
      <meta name="robots" content={noIndex ? 'noindex' : 'all'} />
      <meta name="description" content={description} />
      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description} />
      <meta
        itemProp="image"
        content={"https://drive.google.com/uc?id=1JQ7mUVq9gmJjyFuktTVm3kZ2IeIlmEfe"}
      />
      <meta property="og:title" content={title} />
      <meta property="og:type" content={type} />
      <meta
        property="og:image"
        content={"https://drive.google.com/uc?id=1JQ7mUVq9gmJjyFuktTVm3kZ2IeIlmEfe"}
      />
      <meta property="og:image:width" content={'2048'} />
      <meta property="og:image:height" content={'1200'} />

      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="Encyclopedia of Ludic Terms" />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default SEOHelmet;